export const STATUS_META = {
  fully_vacant: { label: "Available", color: "#347355", bg: "#347355", text: "#FFFFFF" },
  partially_vacant: { label: "Partially Available", color: "#D97736", bg: "#D97736", text: "#FFFFFF" },
  sold: { label: "Sold", color: "#858585", bg: "#858585", text: "#FFFFFF" },
  booked: { label: "Booked", color: "#2C5E7A", bg: "#2C5E7A", text: "#FFFFFF" },
  booking_pending: { label: "Booked Pending Approval", color: "#B08B00", bg: "#EAB308", text: "#1A1F16" },
  hold: { label: "Hold", color: "#DC2626", bg: "#DC2626", text: "#FFFFFF" },
  blocked: { label: "Blocked", color: "#DC2626", bg: "#B91C1C", text: "#FFFFFF" },
  mortgage: { label: "Mortgage", color: "#4B4B4B", bg: "#4B4B4B", text: "#FFFFFF" },
  unknown: { label: "Unknown", color: "#B6B4AD", bg: "#D6D3CA", text: "#1A1F16" },
};

// Approval-status meta for portions (independent of the sale status).
export const APPROVAL_META = {
  approved: { label: "Approved", color: "#347355", bg: "#347355" },
  pending_approval: { label: "Pending Super Admin Approval", color: "#B08B00", bg: "#EAB308" },
  rejected: { label: "Rejected", color: "#DC2626", bg: "#DC2626" },
};

export const statusLabel = (s) => STATUS_META[s]?.label || s;
export const statusColor = (s) => STATUS_META[s]?.color || "#B6B4AD";
export const statusBg = (s) => STATUS_META[s]?.bg || "#D6D3CA";
export const statusText = (s) => STATUS_META[s]?.text || "#1A1F16";

export const formatSqYd = (n) => (n == null ? "—" : `${Number(n).toLocaleString(undefined, { maximumFractionDigits: 1 })} sq.yd`);
export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  } catch { return iso; }
};

// Human-facing role labels. Internally the DB still uses `agent` for backward compatibility.
export const roleLabel = (role) => ({
  agent: "Channel Partner",
  admin: "Admin",
  super_admin: "Super Admin",
  buyer: "Buyer",
  staff: "Staff",
}[role] || role);
